import { render, staticRenderFns } from "./VideoUploaded.vue?vue&type=template&id=08f03ea7&scoped=true"
import script from "./VideoUploaded.vue?vue&type=script&lang=js"
export * from "./VideoUploaded.vue?vue&type=script&lang=js"
import style0 from "./VideoUploaded.vue?vue&type=style&index=0&id=08f03ea7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f03ea7",
  null
  
)

export default component.exports